__webpack_require__.p = "/apps/recommendations/js/";